import AssignParkForm from "./AssignParkForm";
import AssignBlockForm from "./AssignBlockForm";
import AssignParcelForm from "./AssignParcelForm";
import AssignInfrastructureForm from "./AssignInfrastructureForm";
import AssignGreenAreaForm from "./AssignGreenAreaForm";
import AssignShedForm from "./AssignShedForm";
import AsignInfoToOthersForm from "./AsignInfoToOthersForm";
import AssignBuildingForm from "./AssignBuildingForm";

export {
    AssignParkForm,
    AssignBlockForm,
    AssignParcelForm,
    AssignInfrastructureForm,
    AssignGreenAreaForm,
    AssignShedForm,
    AsignInfoToOthersForm,
    AssignBuildingForm
}